























































































































































































































































































































































// NOT PART OF MVP
// import TrashIcon from '@/assets/svgs/trash_icon.svg?inline'
import ArrowBack from '@/assets/svgs/arrow_back.svg?inline'
import Dropdown from '@/components/atoms/Dropdown.vue'
import Button from '@/components/atoms/Button.vue'
import TypeToFilterDropdown from '@/components/atoms/TypeToFilterDropdown.vue'
import ToggleSwitch from '@/components/atoms/ToggleSwitch.vue'
import ISO from 'iso-639-1'
import Vue from 'vue'

export default Vue.extend({
  name: 'FilterSearch',
  props: {
    isFilterDrawerOpen: Boolean
  },
  data: () => ({
    sortOptions: Vue.Constants.LEARNER_SORT_OPTIONS,
    availability: ['Full-time'],
    languages: ISO.getAllNames(),
    additionalSkills: ['Hemodialysis'],
    filtersTabShowing: true,
    activeButton: 1,
    programSkills: [
      {
        id: 1,
        name: 'Anatomy and Physiology'
      },
      {
        id: 2,
        name: 'Customer Service'
      },
      {
        id: 3,
        name: 'EKG and Cardiovascular'
      },
      {
        id: 4,
        name: 'Electronic Medical Records'
      },
      {
        id: 5,
        name: 'Infection Control'
      },
      {
        id: 6,
        name: 'Medical Administrative Assistant'
      },
      {
        id: 7,
        name: 'Medical Laws and Ethics'
      },
      {
        id: 8,
        name: 'Patient Care Coordination'
      },
      {
        id: 9,
        name: 'Pharmacology Basics'
      },
      {
        id: 10,
        name: 'Phlebotomy'
      }
    ]
  }),
  components: {
    // NOT PART OF MVP
    // TrashIcon
    ArrowBack,
    Dropdown,
    Button,
    TypeToFilterDropdown,
    ToggleSwitch
  }
})
